/* import __COLOCATED_TEMPLATE__ from './pii-card.hbs'; */
import Component from '@ember/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';

export default class PiiCard extends Component {
  @service router;

  tagName = '';

  @action
  navigateToEdit() {
    if (this.editRoute) {
      this.router.transitionTo(this.editRoute);
    }
  }
}
